export default __webpack_public_path__ + "static/media/640_dummy2016-restaurant01-de.b40762b3.png";